export const ROUTES = {
  TRANG_CHU: '/trang-chu',
  ID: '/:id',
  PARENT_ID: '/:parent_id',
  CHILD_ID: '/:child_id',
  THEM_MOI: '/them-moi',
  CHI_TIET: '/chi-tiet',
  CHINH_SUA: '/chinh-sua',
  LOGIN: '/login',
  QUAN_TRI_HE_THONG: '/quan-tri-he-thong',
  DON_VI_THEO_DOI: '/don-vi-theo-doi',
  DOI_TUONG_THANH_TRA: '/quan-ly-doi-tuong-thanh-tra',
  NHOM_DOI_TUONG_THANH_TRA: '/nhom-doi-tuong-thanh-tra',
  HOAT_DONG_THANH_TRA: '/hoat-dong-thanh-tra',
  LINH_VUC_THANH_TRA: '/linh-vuc-thanh-tra',
  KIEN_NGHI_TAI_CHINH: '/kien-nghi-tai-chinh',
  BAO_CAO_KIEM_TOAN: '/bao-cao-kiem-toan',
  NHOM_NGUOI_DUNG: '/nhom-nguoi-dung',
  SAO_LUU_DU_LIEU: '/sao-luu-du-lieu',
  DANH_SACH_THONG_BAO: '/danh-sach-thong-bao',
  DANH_SACH_KET_LUAN_THANH_TRA: '/ket-luan-thanh-tra',
  DANH_SACH_KET_LUAN_KTNN: '/ket-luan-KTNN',
  QL_DANH_SACH_KET_LUAN_THANH_TRA: '/quan-ly-ket-luan-thanh-tra',
  QL_DANH_SACH_KIEN_NGHI_THANH_TRA: '/quan-ly-kien-nghi-thanh-tra',
  QL_DANH_SACH_KIEN_NGHI_KIEM_TOAN: '/quan-ly-kien-nghi-kiem-toan',
  QL_DANH_SACH_KET_LUAN_KTNN: '/quan-ly-ket-luan-ktnn',
  DANH_SACH_THUC_HIEN_KIEN_NGHI: '/don-vi-thuc-hien-nghi',
  DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN: '/danh-sach-thuc-hien-nghi-kiem-toan',
  XU_LY_TAI_CHINH: '/xu-ly-tai-chinh',
  XU_LY_CO_CHE_CHINH_SACH: '/xu-ly-co-che-chinh-sach',
  XU_LY_KIEM_DIEM_TRACH_NHIEM: '/xu-ly-kiem-diem-trach-nhiem',
  KTNN_CHAN_CHINH_RUT_KINH_NGHIEM: '/xu-ly-chan-chinh-rut-kinh-nghiem',
  XU_LY_KHAC: '/xu-ly-khac',
  THEO_DOI_KIEN_NGHI_THANH_TRA: '/theo-doi-kien-nghi-thanh-tra',
  THEO_DOI_KIEN_NGHI_KTNN: '/theo-doi-kien-nghi-ktnn',
  QUAN_LY_NGUOI_DUNG: '/quan-ly-nguoi-dung',
  DANH_MUC_VAI_TRO: '/danh-muc-vai-tro',
  QUAN_LY_UNG_DUNG: '/quan-ly-ung-dung',
  DANH_MUC_DON_VI: '/danh-muc-don-vi',
  DANH_MUC_LOAI_NGUON_VON: '/loai-nguon-von',
  DANH_MUC_DU_AN: '/danh-muc-du-an',
  DANH_MUC_LOAI_CHI_PHI: '/loai-chi-phi',
  DANH_MUC_LOAI_KET_LUAN: '/loai-ket-luan',
  DANH_MUC_PHONG_BAN: '/danh-muc-phong-ban',
  DANH_MUC_LOAI_LINH_VUC_VI_PHAM: '/loai-linh-vuc-vi-pham',
  DANH_MUC_LOAI_KIEM_TOAN: '/loai-kiem-toan',
  DANH_MUC_HINH_THUC_XU_LY: '/hinh-thuc-xu-ly',
  DANH_MUC_HINH_THUC_KIEN_NGHI: '/hinh-thuc-kien-nghi',
  DANH_MUC_CHUC_VU: '/danh-muc-chuc-vu',
  PHAN_QUYEN_VAI_TRO: '/phan-quyen-vai-tro',
  BAO_CAO_TONG_HOP_KET_QUA_RA_SOAT_CAC_CUOC_TT_VE_KTXH: '/bao-cao-tong-hop-ket-qua-ra-soat-cac-cuoc-tt-ve-ktxh',
  BAO_CAO_KET_QUA_THUC_HIEN_CAC_NOI_DUNG_KIEN_NGHI_KIEM_TOAN: '/bao-cao-ket-qua-thuc-hien-cac-noi-dung-knkt',
  BAO_CAO_KET_QUA_THUC_HIEN_CAC_NOI_DUNG_KIEN_NGHI_KIEM_TOAN_CHI_TIET:
    '/bao-cao-ket-qua-thuc-hien-cac-noi-dung-knkt/chi-tiet/:nhom/:loai',
  BAO_CAO_KET_QUA_THUC_HIEN_KIEN_NGHI_XU_LY_TC_XU_LY_KHAC: '/bao-cao-ket-qua-thuc-hien-kien-nghi-xu-ly-tc-xu-ly-khac',
  BAO_CAO_TONG_HOP_KET_LUAN_THANH_TRA_KIEM_TOAN: '/bao-cao-tong-hop-ket-luan-thanh-tra-kiem-toan',
  BAO_CAO_TONG_HOP_KET_LUAN_THANH_TRA_KIEM_TOAN_CHI_TIET:
    '/bao-cao-tong-hop-ket-luan-thanh-tra-kiem-toan/chi-tiet/:loai',
  BAO_CAO_KET_QUA_THUC_HIEN_KIEN_NGHI_XU_LY_TC_XU_LY_KHAC_CHI_TIET:
    '/bao-cao-ket-qua-thuc-hien-kien-nghi-xu-ly-tc-xu-ly-khac/chi-tiet/:loai',
  BAO_CAO_TONG_HOP_KET_QUA_THUC_HIEN_KIEN_NGHI_KTXH: '/bao-cao-tong-hop-ket-qua-thuc-hien-kien-nghi-ktxh',
  BAO_CAO_CHI_TIET_KET_QUA_THUC_HIEN_KIEN_NGHI_KTXH:
    '/bao-cao-tong-hop-ket-qua-thuc-hien-kien-nghi-ktxh/chi-tiet/:phanLoai',
  BAO_CAO_CHI_TIET_CAC_VU_VIEC_DOI_TUONG_CHUYEN_CO_QUAN_DIEU_TRA:
    '/bao-cao-chi-tiet-cac-vu-viec-doi-tuong-chuyen-co-quan-dieu-tra',
  BAO_CAO_CHI_TIET_CAC_VU_VIEC_DOI_TUONG_DE_NGHI_CHUYEN_CQDT:
    '/bao-cao-chi-tiet-cac-vu-viec-doi-tuong-de-nghi-chuyen-cqdt',
  BAO_CAO_KET_QUA_XU_LY_CAN_BO_THEO_KLTT_VA_KIEN_NGHI_KTNN: '/bao-cao-ket-qua-xu-ly-can-bo-theo-kltt-va-kien-nghi-ktnn',
  BAO_CAO_CAC_KIEN_NGHI_DA_HOAN_THANH_THEO_CAC_KLTT_KIEN_NGHI_CUA_KTNN:
    '/bao-cao-cac-kien-nghi-da-hoan-thanh-theo-cac-kltt-kien-nghi-cua-ktnn',
  BAO_CAO_CAC_KIEN_NGHI_CHUA_HOAN_THANH_XONG_THEO_CAC_KLTT_KIEN_NGHI_CUA_KTNN:
    '/bao-cao-cac-kien-nghi-chua-hoan-thanh-xong-theo-cac-kltt-kien-nghi-kttn',
  BAO_CAO_TONG_HOP_KET_LUAN_THANH_TRA: '/bao-cao-tong-hop-ket-luan-thanh-tra',
  BAO_CAO_TONG_HOP_THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH_02:
    '/bao-cao-tong-hop-thuc-hien-ket-luan-thanh-tra-hanh-chinh-02',
  BAO_CAO_TONG_HOP_THUC_HIEN_KET_LUAN_QUYET_DINH_XU_PHAT_QUA_THANH_TRA_CHUYEN_NGANH:
    '/bao-cao-tong-hop-thuc-hien-ket-quyet-dinh-xu-phat-qua-thanh-tra-chuyen-nganh',
  BAO_CAO_TONG_HOP_KET_QUA_HANH_CHINH_TRONG_LINH_VUC_TCNS: '/bao-cao-tong-hop-ket-qua-hanh-chinh-trong-linh-vuc-tcns',
  TONG_HOP_KET_QUA_THANH_TRA_HANH_CHINH: '/tong-hop-ket-qua-thanh-tra-hanh-chinh',
  TONG_HOP_KET_QUA_THANH_TRA_HANH_CHINH_TRONG_LINH_VUC_XDCB:
    '/tong-hop-ket-qua-thanh-tra-hanh-chinh-trong-linh-vuc-dau-tu-xdcb',
  TONG_HOP_KET_QUA_THANH_TRA_HANH_CHINH_TRONG_LINH_VUC_DAT_DAI:
    '/tong-hop-ket-qua-thanh-tra-hanh-chinh-trong-linh-vuc-dat-dai',
  TONG_HOP_KET_QUA_THANH_TRA_KIEM_TRA_CHUYEN_NGANH: '/tong-hop-ket-qua-thanh-tra-kiem-tra-chuyen-nganh',
  BAO_CAO_CHI_TIET_KET_QUA_THUC_HIEN_KLTT: '/bao-cao-chi-tiet-ket-qua-thuc-hien-KLTT',
  BAO_CAO_THONG_KE_DONG: '/bao-cao-thong-ke-dong',
  BAO_CAO_TONG_HOP_KET_QUA_THUC_HIEN_KIEN_NGHI: '/bao-cao-tong-hop-ket-qua-thuc-hien-kien-nghi',
  BAO_CAO_TONG_HOP_CAC_KIEN_NGHI_VE_CO_CHE_CHINH_SACH_DA_THUC_HIEN:
    '/bao-cao-tong-hop-cac-kien-nghi-ve-co-che-chinh-sach-da-thuc-hien',
  BAO_CAO_TONG_HOP_KIEN_NGHI_CHAN_CHINH_RUT_KINH_NGHIEM: '/bao-cao-tong-hop-kien-nghi-chan-chinh-rut-kinh-nghiem',
  BAO_CAO_TONG_HOP_KIEN_NGHI_KIEM_DIEM_TRACH_NHIEM_TAP_THE_CA_NHAN:
    '/bao-cao-tong-hop-kien-nghi-kiem-diem-trach-nhiem-ttcn',
  BAO_CAO_TONG_HOP_KIEN_NGHI_KIEM_DIEM_TRACH_NHIEM_CAN_BO_CONG_CHUC_VIEN_CHUC:
    '/bao-cao-tong-hop-kien-nghi-kiem-diem-trach-nhiem-can-bo-cong-chuc-vien-chuc',
  BAO_CAO_TONG_HOP_KET_QUA_THUC_HIEN_KN_TAI_CHINH: '/bao-cao-tong-hop-ket-qua-thuc-hien-KN-tai-chinh',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA: '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CHI_TIET:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/tong',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_DA_THUC_HIEN:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/da-thuc-hien',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CHUA_THUC_HIEN:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/chua-thuc-hien',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCCS:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/cccs',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCCS_CHUA_THUC_HIEN:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/cccs/chua-thuc-hien',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCCS_DA_THUC_HIEN:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/cccs/da-thuc-hien',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_HANH_CHINH:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/hanh-chinh',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_HANH_CHINH_CHUA_THUC_HIEN:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/hanh-chinh/chua-thuc-hien',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_HANH_CHINH_DA_THUC_HIEN:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/hanh-chinh/da-thuc-hien',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCDT:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/chuyen-cqdt',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCDT_CHUA_THUC_HIEN:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/chuyen-cqdt/chua-thuc-hien',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCDT_DA_THUC_HIEN:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/chuyen-cqdt/da-thuc-hien',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_XLK:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/xu-ly-khac',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_XLK_DA_THUC_HIEN:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/xu-ly-khac/da-thuc-hien',
  BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_XLK_CHUA_THUC_HIEN:
    '/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/xu-ly-khac/chua-thuc-hien',
  XUAT_TO_TRINH_KL77: '/xuat-to-trinh-kl77',
  FORBIDDEN_ERROR: '/403'
}
